export default data => {
    let parsedData = null
    try {
        parsedData = JSON.parse(data)
    } finally {
        return parsedData
    }
}